import { Box, List, ListItem, Table, Tbody, Td, Text, Th, Thead, Tooltip, Tr } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

// import "antd/dist/antd.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import CurrencyFormat from "react-currency-format";
import {  FaPen, FaPlusCircle } from "react-icons/fa";
import {  FaEllipsisVertical } from "react-icons/fa6";
import { IoIosClose } from "react-icons/io";
import VendorCustomSelect from "../Vendors/VendorCustomSelect";
import { taxOptions } from "../PurchaseItem/selectedOptions";
import { fetchAsyncGetItem } from "redux/purchaseItemSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { calculateGstAmount, calculateTotalQuantityAndAmount } from "./helperFunction";
import ItemCodePopover from "./updatetemCodePopover";
import { fetchAsyncGetOrganization } from "redux/organizationSlice";
import { fetchAsyncGetVendorByID } from "redux/vendorSlice";
import CustomPopover from "components/customPopover/customPopover";
import { PiExportBold } from "react-icons/pi";
import PurchaseOrderPdf from "./ExportPurchaseOrder/exportPdf";
import AddItemForm from "../PurchaseItem/addItemForm";
import { IoCloseCircleOutline } from "react-icons/io5";
import TextAreaField from "../component/textAreaField";
import InputFormControl from "../component/inputFormControl";
import AmountInputField from "../component/amountField";

const AddItemComponent = ({
  itemList,
  handleListItem,
  handleAddRow,
  handleDeleteRow,
  handleRemoveSelectedItem,
  handleUpdateList,
  handleUpdateItemField,
  merchantValue,
  getData,
  updateTaxableAmount,
  multipleAddGstInfo,
  isTdsPo,
  handleAdjustmentAmount,
  adjustmentAmount,
  editData,
  adjustmentLabel,
  handleAdjustmentLabel
})=>{

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuIndex, setMenuIndex] = useState("");
  const [openAddItem, setOpenAddItem] = useState(false)  
  const [itemListData, setItemListData] = useState([]);
  const purchaseItemList = useSelector((state) => state.purchaseItemData);
  const dispatch = useDispatch();
  const [openlistEditModal,setOpenEditModal] = useState(false)
  const [editListItem,setEditListItem] =  useState({})
  const [editListItemIndex,setEditListItemIndex] =  useState("")
  const [itemData, setItemData] = useState([])
  const [companyTypeValue, setCompanyTypeValue] = useState({});
  const [gstType, setGstType] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [allGst,setAllGst] = useState([])


  const [gstAmount , setGstAmount] = useState({
    c:'',
    s:'',
    i:''
  })

  const organizationList = useSelector((state) => state.organizationData);

  const [total,setTotal] = useState({
    qty:0,
    amt:0,
    gstAmt:0,
  })
 
  useEffect(()=>{
    if(itemList && itemList?.length){
      setItemData(itemList)
      const totalGstAmount = calculateGstAmount(itemList)
      const totalValue = calculateTotalQuantityAndAmount(itemList);

      setTotal({
        ...total,
        qty:totalValue?.qty,
        amt: totalValue?.amt,
        gstAmt:totalGstAmount
      })
      let newGstAmount = { c: 0, s: 0, i: 0 };

      if (gstType === "CGST" || gstType === "SGST") {
        newGstAmount.c = totalGstAmount / 2;
        newGstAmount.s = totalGstAmount / 2;
        newGstAmount.i = 0; 
      } else if (gstType === "IGST") {
        newGstAmount.i = totalGstAmount;
        newGstAmount.c = 0; 
        newGstAmount.s = 0; 
      }

      setGstAmount(newGstAmount);

      const data = {
        bsAmt: Number(totalValue?.amt) + Number(totalGstAmount),
        vId: companyTypeValue,
        gstNo:gstNumber,
        prc:"",
        amt: newGstAmount
      };
      getData(data)
      updateTaxableAmount(Number(totalValue?.amt) + Number(adjustmentAmount || 0))

    }
    else{
      setItemData([])

    }
  },[itemList,gstType,gstNumber])
  
  const handleFocus = (i) => {
    setIsMenuOpen(true);
    setMenuIndex(i)
  };

  const handleBlur = () => {
      setIsMenuOpen(false);
      setMenuIndex("")
  };
  const handleOpenAddItem = ()=>{
    setOpenAddItem(!openAddItem)
    handleBlur()
  }
  const handleCloseAddItem = ()=>{
    setOpenAddItem(!openAddItem)
    getAllItemListData();
    setOpenEditModal(false);
    setEditListItem({});
    setEditListItemIndex("")

  }

  const handleEditListItem = (item,index)=>{
    setOpenEditModal(true);
    setEditListItem(item);
    setEditListItemIndex(index)
    handleOpenAddItem()

  }
  const getAllItemListData = ()=>{
    dispatch(fetchAsyncGetItem())
      .then(() => {
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  const getCompanyByID = async(id)=>{
    await dispatch(fetchAsyncGetVendorByID(id)).then((res)=>{

    if(res?.payload){
      const vendor = res?.payload?.vendor;
      const setData = {
        label: vendor.name,
        value: vendor?._id,
      };
            
      setCompanyTypeValue(setData);
      if (vendor?.gsts) {
        const gstNumbers = vendor?.gsts.map(gst => gst.gstNo); 
        setAllGst(gstNumbers); 
      }
      else{
        setAllGst([vendor?.gstNo])
      }
    }
    }).catch((err)=>{
      console.log(err)
    })
  }

  useEffect(()=>{
    if(multipleAddGstInfo && multipleAddGstInfo?.length){
      const gstData = multipleAddGstInfo[0];
      if(gstData?._id){

        const {vId,gstNo,amt} = gstData?._id;
          if(vId){
            getCompanyByID(vId)
          }
          if(gstNo && !gstNumber){
            setGstNumber(gstNo)
          }
          if(merchantValue?.value && vId && merchantValue?.value !== vId){
            setGstNumber(gstNumber)
            getCompanyByID(merchantValue?.value)

          }
          if(!amt){
            setGstAmount(amt)
          }
      }
      else{
        if(merchantValue && merchantValue?.value){
          getCompanyByID(merchantValue?.value)
        }
      } 
    }
    else{

     
        getCompanyByID(merchantValue?.value)
      
    }
  },[multipleAddGstInfo,merchantValue])
  useEffect(() => {
    dispatch(fetchAsyncGetOrganization())
  }, []);

  useEffect(() => {
    if(isMenuOpen){
      getAllItemListData()
    }
  }, [isMenuOpen]);

  useEffect(()=>{
    if(gstNumber && organizationList?.length){
      const stateCode = gstNumber?.substring(0, 2);
      const gstCode = organizationList[0]?.gstNo;
      const organizationStateCode = gstCode?.substring(0, 2);
      if(stateCode === organizationStateCode){
        setGstType('SGST')
      }
      else{
        setGstType('IGST')
      }
    }
    else{
      setGstType('IGST')
    }
  },[gstNumber,organizationList])

  

  const handleUpdateListItem = (item)=>{
    handleUpdateList(item,editListItemIndex)
    handleCloseAddItem();    
  }
 
    useEffect(()=>{
      setItemListData(purchaseItemList)
    },[purchaseItemList])

    const handleItemSearch = (e) => {
      const value = e?.target?.value;
      if (!value) {
        getAllItemListData()
      }
      else{
        const filterData = itemListData.filter(
          (option) =>
            option.name.toLowerCase().indexOf(value.toLowerCase()) >= 0
        );
        setItemListData(filterData)

      }
  
    }; 
    const [openExportMenu,setOpenExportMenu] = useState(false)
   
    
    return (
      <>
        <Box className="item-table-label">
          <span className="lable-text">Item Table</span>

          {editData?._id && (
            <div className="item-export-menu">
              <Tooltip
                label="Export"
                placement="bottom"
                hasArrow
                className="common-tooltip"
              >
                <div
                  className="menu-ellipsis-btn"
                  onClick={() => setOpenExportMenu(!openExportMenu)}
                >
                  <PiExportBold />
                </div>
              </Tooltip>
            </div>
          )}
        </Box>
        <div className="ember-view">
          <Table className="line-item-table line-item-table-light">
            <Thead className="line-item-header bill-items">
              <Tr>
                <Th className="line-item-column over-flow col-number">No.</Th>
                <Th className="line-item-column over-flow bill-desc-us">
                  Item Details
                </Th>
                <Th className="line-item-column over-flow text-end item-qty">
                  Quantity
                </Th>
                <Th className="line-item-column text-end item-rate">Rate</Th>
                <Th className="line-item-column text-end item-tax">Tax</Th>

                <Th className="line-item-column  text-end item-amount-us">
                  Amount
                </Th>
                <Th className=""></Th>
              </Tr>
            </Thead>
            <Tbody className="ember-view line-item-body">
              {itemData && itemData?.length
                ? itemData?.map((item, i) => {
                    return (
                      <Tr className="ember-view line-item bill-items new-line-item">
                        <Td className="ember-view line-item-column item-details col-number">
                          <Text className="item-number">{i + 1}</Text>
                        </Td>
                        <Td className="ember-view line-item-column item-details bill-desc-us">
                          {item?.slItm?._id ? (
                            <Box className="item-content ">
                              <div className="name">
                                <Box className="name-action" display="flex">
                                  <Text className="label">
                                    {item?.slItm?.name}
                                  </Text>

                                  <div className="item-name-actions-container">
                                    <div className="item-actions">
                                      <div
                                        className={`icon-btn ${
                                          isTdsPo ? "not-allow" : ""
                                        }`}
                                        onClick={() =>
                                          !isTdsPo &&
                                          handleEditListItem(item?.slItm, i)
                                        }
                                      >
                                        <FaPen size={14} className="icon" />
                                      </div>
                                      <div
                                        className={`icon-btn ${
                                          isTdsPo ? "not-allow" : ""
                                        }`}
                                        onClick={() =>
                                          !isTdsPo &&
                                          handleRemoveSelectedItem(i)
                                        }
                                      >
                                        <IoIosClose
                                          size={16}
                                          className="iconclose"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Box>
                                <Text className="sku-id">
                                  SKU : {item?.slItm?.sCd}
                                </Text>
                              </div>
                              <TextAreaField
                                customClass={`ember-text-area form-control content-description item-description ember-view}`}
                                name="description"
                                isDisabled={isTdsPo}
                                value={item?.slItm?.dc}
                                handleChange={(e) =>
                                  handleUpdateItemField(
                                    e.target.value,
                                    "description",
                                    i
                                  )
                                }
                                placeholder="Add a description to your item"
                              />
                              <div className="item-tratment">
                                <Text className="type ">
                                  {item?.slItm?.typ}
                                </Text>
                                <Text display="flex" className="itemcode">
                                  {item?.slItm?.typ === "goods" ? "HSN" : "SAC"}{" "}
                                  Code:
                                  <span className="hsnvalue">
                                    {item?.slItm?.typ === "goods"
                                      ? item?.slItm?.hCd
                                      : item?.slItm?.sCd}{" "}
                                  </span>
                                  <Box className="icon-btn mt-1 mx-2 hsnvalue">
                                    {!isTdsPo && (
                                      <ItemCodePopover
                                        type={item?.slItm?.typ}
                                        value={
                                          item?.slItm?.typ === "goods"
                                            ? item?.slItm?.hCd
                                            : item?.slItm?.sCd
                                        }
                                        handleSave={(value, name) =>
                                          handleUpdateItemField(value, name, i)
                                        }
                                        isTdsPo={isTdsPo}
                                      />
                                    )}
                                  </Box>
                                </Text>
                              </div>
                            </Box>
                          ) : (
                            <TextAreaField
                              customClass="ember-text-area form-control item-description ember-view"
                              placeholder="Type or click to select an item."
                              name="remarks"
                              onFocus={() => handleFocus(i)}
                              handleChange={(e) => handleItemSearch(e)}
                            />
                          )}

                          {isMenuOpen && menuIndex === i && (
                            <Box className="item-menu-popup">
                              {!itemListData && !itemListData?.length ? (
                                <Text className="no-result">
                                  No Results Found. Try a diffrent Keyword.{" "}
                                </Text>
                              ) : (
                                <Box className="menu-item-list">
                                  <Box
                                    float="right"
                                    onClick={() => handleBlur()}
                                    cursor="pointer"
                                  >
                                    <IoCloseCircleOutline
                                      size={20}
                                      color="red"
                                      border={1}
                                    />
                                  </Box>
                                  <List className="mt-4">
                                    {itemListData &&
                                      itemListData?.map((data, index) => {
                                        return (
                                          <ListItem
                                            className="list-item"
                                            id={index}
                                            onClick={() => {
                                              handleListItem(data, i);
                                              handleBlur();
                                            }}
                                          >
                                            <Text className={`label`}>
                                              {data?.name}
                                            </Text>
                                            <p className={`helper`}>
                                              SKU: {data?.sCd} Purchase Rate: ₹
                                              {formatAmountIndianRupees(
                                                data?.prc
                                              )}
                                            </p>
                                          </ListItem>
                                        );
                                      })}
                                  </List>
                                </Box>
                              )}
                              <Box className="add-new-item-btn mt-3">
                                <Button
                                  className="btn mx-0"
                                  onClick={() => {
                                    handleOpenAddItem();
                                  }}
                                >
                                  <FaPlusCircle
                                    className="add-item-icon"
                                    size={16}
                                  />
                                  <Text className="btn-text mx-2">
                                    Add New Item
                                  </Text>
                                </Button>
                              </Box>
                            </Box>
                          )}
                        </Td>
                        <Td className="ember-view line-item-column item-qty">
                          <InputFormControl
                            type="number"
                            value={item?.qty || ""}
                            name="quantity"
                            isDisabled={isTdsPo}
                            customClass="ember-text-field text-end ember-view"
                            handleChange={(e) =>
                              handleUpdateItemField(
                                e?.target?.value,
                                "quantity",
                                i
                              )
                            }
                          />
                          <Text className="text-end mx-2" fontSize={12}>
                            {item?.slItm?.unt?.value}
                          </Text>
                        </Td>
                        <Td className="ember-view line-item-column item-rate">
                          <CurrencyFormat
                            customInput={Form.Control}
                            className={`ember-text-field text-end ember-view form-control `}
                            type="text"
                            name="rate"
                            value={item?.prc || ""}
                            placeholder=""
                            disabled={isTdsPo}
                            thousandSeparator={true}
                            // prefix={"$"}
                            onValueChange={(e) =>
                              handleUpdateItemField(e?.value, "rate", i)
                            }
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </Td>
                        <Td className="ember-view line-item-column item-tax select-tax-options">
                          <VendorCustomSelect
                            options={taxOptions}
                            placeHolder="Select a tax"
                            defaultValue={item?.tax}
                            isSearchable
                            isDisabled={isTdsPo}
                            onChange={(newValue) =>
                              handleUpdateItemField(newValue, "tax", i)
                            }
                          />
                        </Td>
                        <Td className="ember-view line-item-column text-end item-amount-us">
                          {Number(item?.amt || 0).toFixed(2)}
                          <div className="item-actions-container">
                            <div className="item-actions">
                              <div className=" ellipsis-btn no-caret  text-blue">
                                <FaEllipsisVertical />
                              </div>
                              <div
                                className={`item-close-btn icon-button action ${
                                  isTdsPo ? "not-allow" : ""
                                }`}
                                onClick={(e) =>
                                  !isTdsPo && handleDeleteRow(e, i)
                                }
                              >
                                <IoIosClose size={28} />
                              </div>
                            </div>
                          </div>
                        </Td>
                      </Tr>
                    );
                  })
                : null}
            </Tbody>
          </Table>
          <Row>
            <Col className="col-lg-3">
              <Box display="flex" alignItems="center" className=" add-item-btn">
                <Button
                  className={`btn mt-2 mx-0 ${isTdsPo ? "not-allow" : ""}`}
                  onClick={() => handleAddRow()}
                  disabled={isTdsPo}
                >
                  <FaPlusCircle className="add-item-icon" size={16} />
                  <Text className="btn-text">Add New Row</Text>
                </Button>
              </Box>
            </Col>

            <Col>
              <Box className="invoice-discount ms-auto col-lg-9 px-0 mt-5 me-4">
                <div className="total-section rounded-xlg px-4 py-3 total-section-bg">
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    className=" sub-total text-semibold "
                  >
                    <div className="total-label">
                      Sub Total <br />
                      <div className="font-xxs">
                        Total Quantity : {total?.qty || 0}
                      </div>
                    </div>
                    <div className="total-amount text-semibold">
                      {formatAmountInINR(total?.amt || 0)}
                    </div>
                  </Box>
                  <div className="total-row gst-number-row sub-total text-semibold ">
                    <div className="total-label">
                      GST Number <br />
                    </div>
                    <div className="total-amount text-semibold">
                      <Box>
                        <Form.Select
                          className="custom--dropdown-container"
                          value={gstNumber}
                          onChange={(e) => {
                            setGstNumber(e.target.value);
                          }}
                        >
                          <option value="">Select GST Number</option>
                          {allGst &&
                            allGst?.length > 0 &&
                            allGst?.map((gst) => {
                              return <option value={gst}>{gst}</option>;
                            })}
                        </Form.Select>
                      </Box>
                    </div>
                  </div>

                  {gstType === "IGST" ? (
                    <>
                      <Box
                        display="flex"
                        width="100%"
                        justifyContent="space-between"
                      >
                        <div className="mt-3 ">
                          <label for="IGST" className="mx-1 gst-label">
                            IGST
                          </label>
                        </div>
                        <div className="mt-3">
                          {formatAmountInINR(gstAmount?.i || 0)}{" "}
                        </div>
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box
                        display="flex"
                        width="100%"
                        justifyContent="space-between"
                      >
                        <div className="mt-3 ">
                          <label for="CGST" className="mx-1 gst-label">
                            CGST
                          </label>
                        </div>
                        <div className="mt-3">
                          {formatAmountInINR(gstAmount?.c || 0)}{" "}
                        </div>
                      </Box>
                      <Box
                        display="flex"
                        width="100%"
                        justifyContent="space-between"
                      >
                        <div className="mt-3 ">
                          <label for="SGST" className="mx-1 gst-label">
                            SGST
                          </label>
                        </div>
                        <div className="mt-3">
                          {formatAmountInINR(gstAmount?.s || 0)}{" "}
                        </div>
                      </Box>
                    </>
                  )}
                  <div className="total-row">
                    <div className="total-label">
                      <div className="row">
                        <div className="col-lg-5">
                          <div className="input-group adjusment-div">
                            <InputFormControl
                             customClass="ember-text-field  ember-view form-control"
                             type="text"
                             value={adjustmentLabel}
                             handleChange={handleAdjustmentLabel}
                            />
                           
                          </div>
                        </div>
                        <div className="col-lg-7">
                          <div className="input-group">
                          <AmountInputField
                              customClass="ember-text-field text-end ember-view"
                              name="adjustmentAmount"
                              value={adjustmentAmount || ""}
                              handleChange={(value) => {
                                handleAdjustmentAmount(value);
                              }}
                              InputGroupText={
                                <div className="mx-1 mt-2">
                                <CustomPopover popoverText="Add any other +ve or -ve charges that need to be applied to adjust the total amount of the transaction Eg. + 10 or -10." />
                                </div>
                              }
                            />
                            
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="total-amount mt-3">
                      {formatAmountInINR(adjustmentAmount || 0)}
                    </div>
                  </div>
                  <Box display="flex" justifyContent="space-between" className="text-semibold mt-3 pt-2  border-top">
                    <div className="total-label">Total</div>
                    <div className="total-amount">
                      {formatAmountInINR(
                        total?.amt + total?.gstAmt + Number(adjustmentAmount || 0)
                      )}
                    </div>
                  </Box>
                </div>
              </Box>
            </Col>
          </Row>
        </div>
        {openAddItem && (
          <AddItemForm
            isOpen={openAddItem}
            closeModal={() => {
              handleCloseAddItem();
            }}
            isEdit={openlistEditModal}
            editData={editListItem}
            updateListItem={(item) => handleUpdateListItem(item)}
            listItemBtn={true}
          />
        )}
        {openExportMenu && (
          <PurchaseOrderPdf
            isOpen={openExportMenu}
            onClose={() => setOpenExportMenu(!openExportMenu)}
            expenseData={editData}
            vendorGst={gstNumber}
            itemList={itemData}
            gstAmount={gstAmount}
            total={total}
            adjustmentAmount={adjustmentAmount}
            adjustmentLabel={adjustmentLabel}
            gstType={gstType}
            vendorId={merchantValue?.value}
          />
        )}
      </>
    );
}

export default AddItemComponent;